module.exports = __webpack_public_path__ + "static/assets/f08d5668d9f430e10e43aebd91aacc3e.svg";